module.exports = __webpack_public_path__ + "static/media/k11-logo.885612d4.png";